import { AfterViewInit, Component, inject, OnInit, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { Router } from "@angular/router";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { MasterService } from "@frontend/app/serivces/master.service";
import { _ } from "@angular/cdk/number-property.d-CJVxXUcb";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { tap } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { OrderStatusComponent } from "../order-status/order-status.component";
interface OrderItem {
  name: string;
  size: string;
  quantity: number;
  price: number;
  stock: number;
}

interface Order {
  id: string;
  customerName: string;
  email: string;
  phone: string;
  address: string;
  date: Date;
  status: "PENDING" | "APPROVED" | "REJECTED";
  items: OrderItem[];
  total: number;
}
@Component({
  selector: "app-orders-list",
  imports: [CommonModule, SharedModule],
  templateUrl: "./orders-list.component.html",
  styleUrl: "./orders-list.component.scss",
})
export class OrdersListComponent implements AfterViewInit {
  private masterService = inject(MasterService);
  private router = inject(Router);
  private matdialog = inject(MatDialog);

  ngAfterViewInit(): void {
    this.paginator.page.pipe(tap(() => this.getOrderList(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction))).subscribe();
    this.sort.sortChange.subscribe(() => {
      this.getOrderList(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
    });
    this.getOrderList(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
  }

  orders: Order[] = [
    {
      id: "1",
      customerName: "harsh patel",
      email: "harsh@gmail.com",
      phone: "1234567890",
      address: "Adajan , Surat",
      date: new Date("2026-01-01"),
      status: "PENDING",
      total: 500,
      items: [
        { name: "Uniform", size: "L", quantity: 5, price: 400, stock: 50 },
        { name: "Head Guard", size: "L", quantity: 5, price: 50, stock: 50 },
        { name: "Mouth Guard", size: "L", quantity: 5, price: 50, stock: 50 },
      ],
    },
    // Added a second order to demonstrate the list layout
    // {
    //   id: "2",
    //   customerName: "Amit Shah",
    //   email: "amit@test.com",
    //   phone: "9876543210",
    //   address: "Vesu , Surat",
    //   date: new Date("2026-01-02"),
    //   status: "PENDING",
    //   total: 120,
    //   items: [{ name: "Boxing Gloves", size: "M", quantity: 2, price: 120, stock: 12 }],
    // },
  ];
  orderList: any;
  displayedColumns: string[] = ["TrainerName", "CenterName", "CreatedDate", "Quantity", "TotalAmount", "Action"];
  dataSource = new MatTableDataSource();
  length = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  readonly SVG_ICONS = SVG_ICONS;

  getOrderList(pageIndex: number, pageSize: number, sortColumn: string, sortDirection: string) {
    const sort = sortColumn ? `ORDER BY ${sortColumn} ${sortDirection}` : "ORDER BY OrderID asc";

    this.masterService.getOrdersList(pageIndex, pageSize, sort.toString(), sessionStorage.getItem("selectedCenter") || "").subscribe((res: any) => {
      this.dataSource.data = res.data;
      console.log(res);

      this.length = res.totalCount;
    });
  }

  addOrder() {
    this.router.navigate(["add-order"]);
  }

  viewOrder(id: number) {
    const dialogRef = this.matdialog.open(OrderStatusComponent, {
      data: { orderId: id },
      width: "60%",
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getOrderList(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
      }
    });
  }
}
